export const debounceFn: <F extends (...args: Parameters<F>) => ReturnType<F>>(
  func: F,
  waitFor: number,
) => (...args: Parameters<F>) => void = <
  F extends (...args: Parameters<F>) => ReturnType<F>,
>(
    func: F,
    waitFor: number,
  ) => {
  let timeout: NodeJS.Timeout;

  return (...args: Parameters<F>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), waitFor);
  };
};
